import { render, staticRenderFns } from "./DnTagsBox.vue?vue&type=template&id=0b4e3ceb&scoped=true&"
import script from "./DnTagsBox.vue?vue&type=script&lang=js&"
export * from "./DnTagsBox.vue?vue&type=script&lang=js&"
import style0 from "./DnTagsBox.vue?vue&type=style&index=0&id=0b4e3ceb&lang=scss&scoped=true&"
import style1 from "./DnTagsBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e3ceb",
  null
  
)

export default component.exports